import React, { useState } from "react"
import {
    Slide,
    Box,
    Typography,
    Checkbox,
    FormControlLabel,
    Button,
    Paper,
    Divider,
    IconButton
} from "@mui/material"
import { Modal, Backdrop } from "@material-ui/core"
import { styled } from "@mui/material/styles"
import CloseIcon from "@mui/icons-material/Close"

const StyledPaper = styled(Paper)(({ theme }) => ({
    width: "90%",
    maxWidth: 600,
    maxHeight: "90vh",
    overflow: "auto",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[24],
    borderRadius: 12,
    outline: "none",
    margin: "auto"
}))

const TermsModal = ({ open, onAccept, onClose, loading = false }) => {
    const [accepted, setAccepted] = useState(false)

    const handleAcceptChange = (event) => {
        setAccepted(event.target.checked)
    }

    const handleAccept = () => {
        if (accepted && onAccept) {
            onAccept()
        }
    }

    const handleClose = () => {
        if (onClose && !loading) {
            setAccepted(false)
            onClose()
        }
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            // BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500
            }}
            disableEscapeKeyDown={loading}
            disableBackdropClick={true}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
            <Slide direction='down' in={open} mountOnEnter unmountOnExit>
                <StyledPaper>
                    <Box sx={{ p: 4 }}>
                        {/* Header */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 3
                            }}>
                            <Typography
                                variant='h5'
                                component='h2'
                                sx={{ fontWeight: 600, color: "#2563eb" }}>
                                Terms & Conditions
                            </Typography>
                            {!loading && (
                                <IconButton onClick={handleClose} size='small'>
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </Box>

                        {/* Terms Content */}
                        <Box>
                            <Typography
                                variant='h6'
                                sx={{ mb: 2, color: "#1976d2" }}>
                                FinSoftAi SST Research End User License
                                Agreement
                            </Typography>

                            <Typography
                                variant='body1'
                                sx={{ mb: 2, lineHeight: 1.6 }}>
                                By clicking "Accept," you agree to these terms
                                for using SST Research:
                            </Typography>

                            <Box
                                component='ol'
                                sx={{
                                    pl: 2,
                                    "& li": { mb: 1.5, lineHeight: 1.6 }
                                }}>
                                <li>
                                    <strong>Free 30-Day License</strong> – You
                                    may use the Service for free for 30 days.
                                    FinSoftAi may revoke or terminate this
                                    license at its discretion.
                                </li>
                                <li>
                                    <strong>Fair Use</strong> – Use the Service
                                    legally and responsibly. No misuse,
                                    unauthorized access, or disruptions.
                                </li>
                                <li>
                                    <strong>No Guarantees</strong> – The Service
                                    is provided "as is." We are not liable for
                                    any decisions or outcomes based on it.
                                </li>
                                <li>
                                    <strong>Privacy & Data</strong> – We collect
                                    and use your data to provide and improve the
                                    Service. We do not sell your data. Your
                                    information may be shared with service
                                    providers only as needed to operate the
                                    Service.
                                </li>
                                <li>
                                    <strong>Account Suspension</strong> – We may
                                    suspend or terminate accounts that violate
                                    these terms.
                                </li>
                                <li>
                                    <strong>Updates</strong> – We may modify
                                    these terms. Continued use means acceptance
                                    of any updates.
                                </li>
                                <li>
                                    By clicking "Accept," you confirm that you
                                    understand and accept these terms.
                                </li>
                            </Box>
                        </Box>

                        {/* Acceptance Checkbox */}
                        <Box>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={accepted}
                                        onChange={handleAcceptChange}
                                        disabled={loading}
                                        color='primary'
                                    />
                                }
                                label='I have read and agree to the terms and conditions'
                            />
                        </Box>

                        {/* Action Buttons */}
                        <Box
                            sx={{
                                display: "flex",
                                gap: 2,
                                justifyContent: "flex-end"
                            }}>
                            {!loading && (
                                <Button
                                    onClick={handleClose}
                                    variant='outlined'
                                    sx={{ minWidth: 100 }}>
                                    Cancel
                                </Button>
                            )}
                            <Button
                                onClick={handleAccept}
                                disabled={!accepted || loading}
                                variant='contained'
                                sx={{
                                    minWidth: 100,
                                    backgroundColor: "#059669",
                                    "&:hover": {
                                        backgroundColor: "#047857"
                                    }
                                }}>
                                {loading ? "Processing..." : "Accept"}
                            </Button>
                        </Box>
                    </Box>
                </StyledPaper>
            </Slide>
        </Modal>
    )
}

export default TermsModal
